// Перенес код Cropper'а из .phtml шаблона
import $ from 'jquery';
import 'blueimp-file-upload/js/vendor/jquery.ui.widget';
import 'blueimp-file-upload/js/jquery.iframe-transport';
import 'blueimp-file-upload/js/jquery.fileupload';
import {initSortable} from './sort';
import initDeleteFieldVariantFiles from './delete-field-variants-files';
import {Modal} from "bootstrap";

const fieldsTypeStandard = 'standard';
const progressHiddenClass = 'progress--hidden';

const defaultFileuploadOptions = {
  replaceFileInput: true,
  dataType: 'json',
  dropZone: null,
};

function checkAddedFieldFiles(field, filesType, maxFiles = 1) {
  const oneFileErrorMessage = 'Превышено допустимое количество файлов для бесплатных конкурсов';
  let parent = field.closest('.form__card');
  const errorBlock = parent.querySelector('.field-action-status-messages');
  const addedFilesSelector = '.js-' + filesType + '-upload-result .js-' + filesType + '-upload-input-hidden';
  let addedFiles = parent.querySelectorAll(addedFilesSelector);

  if (addedFiles.length >= maxFiles) {
    errorBlock.innerHTML = '<div class="field_error_message">' + oneFileErrorMessage + '</div>'

    return false;
  }

  errorBlock.innerHTML = '';

  return true;
}

function bindFileUploadFail($input, $wrap, options) {
  const {
    errorSelector,
    progressSelector,
    progressErrorClass,
    loadingSelector,
    loadingHideClass = 'hidden',
  } = options;

  $input.on('fileuploadfail', function (e, data) {
    if (loadingSelector) {
      $wrap.find(loadingSelector).addClass(loadingHideClass);
    }

    const errorWrap = $wrap.find(errorSelector);
    errorWrap.empty();

    if (data.jqXHR?.responseJSON) {
      const response = data.jqXHR.responseJSON;

      if (Array.isArray(response.message)) {
        response.message.forEach(function (message) {
          errorWrap.append('<div>' + message + '</div>');
        });
        $wrap.find(progressSelector).addClass(progressErrorClass);
        $input.val('');
        return;
      }

      if (response.message) {
        errorWrap.text(response.message);
        $wrap.find(progressSelector).addClass(progressErrorClass);
        $input.val('');
        return;
      }
    }

    errorWrap.text('Не удалось загрузить файл. Попробуйте ещё раз.');
    $wrap.find(progressSelector).addClass(progressErrorClass);
    $input.val('');
  });
}

function markUploadBound($wrap) {
  if ($wrap.data('uploadBound') === 1) {
    return false;
  }

  $wrap.data('uploadBound', 1);

  return true;
}

function hideUploadProgressContainer($wrap, progressSelector, progressErrorClass) {
  $wrap.find(progressSelector)
    .removeClass(progressErrorClass)
    .attr('aria-valuenow', 0)
    .css('width', 0)
    .empty()
    .closest('.progress')
    .addClass(progressHiddenClass)
    .hide();
}

function showUploadProgress($wrap, progressSelector, progressErrorClass) {
  $wrap.find(progressSelector)
    .closest('.progress')
    .removeClass(progressHiddenClass)
    .show();
  $wrap.find(progressSelector)
    .removeClass(progressErrorClass)
    .attr('aria-valuenow', 0)
    .css('width', 0)
    .empty();
}

function resetUploadFieldState($wrap, $input, options) {
  const {
    errorSelector,
    progressSelector,
    progressErrorClass,
    loadingSelector,
    loadingHideClass = 'hidden',
    inputSelector,
  } = options;

  const $activeInput = inputSelector ? $wrap.find(inputSelector).first() : $input;

  $activeInput.val('');
  $wrap.find(errorSelector).empty();
  hideUploadProgressContainer($wrap, progressSelector, progressErrorClass);
  $wrap.find('.wb-upload-dropzone').show();

  if (loadingSelector) {
    $wrap.find(loadingSelector).addClass(loadingHideClass);
  }
}

function appendUploadResultHtml($wrap, $input, $result, url, params, stateOptions, afterAppend) {
  $.getJSON(url, params)
    .done(function (response) {
      if (response && response.html) {
        $result.append(response.html);

        if (afterAppend) {
          afterAppend();
        }
      } else {
        $wrap.find(stateOptions.errorSelector).text('Не удалось получить данные загруженного файла.');
      }

      resetUploadFieldState($wrap, $input, stateOptions);
    })
    .fail(function () {
      $wrap.find(stateOptions.errorSelector).text('Не удалось получить данные загруженного файла.');
      $wrap.find(stateOptions.progressSelector).addClass(stateOptions.progressErrorClass);
      resetUploadFieldState($wrap, $input, stateOptions);
    });
}

function bindUploadResultRemove($result, $wrap, inputSelector, resultItemSelector, resultRemoveSelector, stateOptions) {
  $result.off('click.uploadRemove', resultRemoveSelector);
  $result.on('click.uploadRemove', resultRemoveSelector, function () {
    $(this).closest(resultItemSelector).remove();
    resetUploadFieldState($wrap, $wrap.find(inputSelector).first(), {
      ...stateOptions,
      inputSelector,
    });
  });
}

function getUploadUrl($input) {
  return $input.attr('data-url') || $input.data('url') || undefined;
}

function isEmbedWorkContentPage() {
  return /\/(wb|frame)\/[^/]+\/work-content/.test(window.location.pathname);
}

function getCropperExportCanvas(cropper) {
  if (!cropper) {
    return null;
  }

  const croppedCanvas = cropper.getCroppedCanvas({
    imageSmoothingEnabled: true,
    imageSmoothingQuality: 'high',
  });

  if (croppedCanvas && croppedCanvas.width > 0 && croppedCanvas.height > 0) {
    return croppedCanvas;
  }

  const fullCanvas = cropper.getCanvas();

  if (fullCanvas && fullCanvas.width > 0 && fullCanvas.height > 0) {
    return fullCanvas;
  }

  return null;
}

function hideCropperModal(cropperModal, cropContainer, confirmBtn) {
  try {
    cropperModal?.hide();
  } catch (error) {
    const modalEl = document.querySelector('#CropperModal');

    if (modalEl && typeof bootstrap !== 'undefined') {
      bootstrap.Modal.getOrCreateInstance(modalEl)?.hide();
    }
  }

  if (cropContainer) {
    cropContainer.style.display = 'none';
  }

  if (confirmBtn) {
    confirmBtn.style.display = 'none';
  }
}

function canOpenHeroImageCropper(uploadInput) {
  const contestIdInput = document.querySelector('input[name="contestId"]');

  if (!contestIdInput || uploadInput.id !== 'image') {
    return true;
  }

  const existImages = uploadInput.closest('.js-images-upload')
    ?.querySelectorAll('.js-images-upload-result .js-images-upload-input-hidden') || [];
  const contestId = contestIdInput.value;

  return (
    (existImages.length > 0 && contestId === '3909')
    || (existImages.length < 5 && contestId === '4595')
    || existImages.length === 0
  );
}

function getWorkUploadFormElement(fromElement) {
  return fromElement?.closest('form')
    || document.querySelector('form.form')
    || document.querySelector('form');
}

function bindDirectImageUploadInput($wrap, $input, options) {
  const {
    progressSelector,
    resultSelector,
    resultRemoveSelector,
    errorSelector,
    progressErrorClass,
  } = options;

  const $progress = $wrap.find(progressSelector);
  const $result = $wrap.find(resultSelector);

  if (!$input.length || !$progress.length || !$result.length || $input.data('directUploadBound') === 1) {
    return;
  }

  $input.data('directUploadBound', 1);

  $input.fileupload({
    ...defaultFileuploadOptions,
    url: getUploadUrl($input),
  });

  bindFileUploadFail($input, $wrap, {
    errorSelector,
    progressSelector,
    progressErrorClass,
  });

  const uploadStateOptions = {
    errorSelector,
    progressSelector,
    progressErrorClass,
    inputSelector: '.js-image-upload-input-crop, .upload-image-input, .js-images-upload-input',
  };

  hideUploadProgressContainer($wrap, progressSelector, progressErrorClass);

  $input.on('fileuploadadd', function () {
    showUploadProgress($wrap, progressSelector, progressErrorClass);
    $wrap.find(errorSelector).empty();
  });

  const imageUploadFormUrl = $result.data('url');

  $input.on('fileuploaddone', function (e, data) {
    if (data.result.status === 'ok') {
      const file = data.result.files[0];

      appendUploadResultHtml(
        $wrap,
        $input,
        $result,
        imageUploadFormUrl,
        { id: file.id },
        uploadStateOptions,
        function () {
          initSortable($result[0]);
        }
      );
    } else {
      const errorWrap = $wrap.find(errorSelector);

      if (Array.isArray(data.result.message)) {
        data.result.message.forEach(function (message) {
          errorWrap.append('<div>' + message + '</div>');
        });
      } else {
        errorWrap.text(data.result.message);
      }

      $progress.addClass(progressErrorClass);
    }
  });

  $input.on('fileuploadprogress', function (e, data) {
    const progress = parseInt(data.loaded / data.total * 100, 10);
    const progressPercent = progress + '%';
    $progress
      .removeClass(progressErrorClass)
      .attr('aria-valuenow', progress)
      .css('width', progressPercent)
      .text(progressPercent);
  });

  bindUploadResultRemove(
    $result,
    $wrap,
    '.js-image-upload-input-crop, .upload-image-input, .js-images-upload-input',
    '.js-images-upload-result-item',
    resultRemoveSelector,
    uploadStateOptions
  );
}

function initDocumentsUpload() {
  const wrapSelector = '.js-documents-upload';
  const inputSelector = '.js-documents-upload-input';
  const progressSelector = '.js-documents-upload-progress';
  const resultSelector = '.js-documents-upload-result';
  const resultItemSelector = '.js-documents-upload-result-item';
  const resultRemoveSelector = '.js-documents-upload-result-remove';
  const errorSelector = '.js-documents-upload-error';

  const $wrapList = $(wrapSelector);

  const progressErrorClass = 'progress__bar_error';

  $wrapList.each(function () {
    const $wrap = $(this);

    const $input = $wrap.find(inputSelector);
    const $progress = $wrap.find(progressSelector);
    const $result = $wrap.find(resultSelector);

    if (!$wrap.length || !$input.length || !$progress.length || !$result.length) return;
    if (!markUploadBound($wrap)) return;

    $input.fileupload({
      ...defaultFileuploadOptions,
      url: getUploadUrl($input),
    });

    bindFileUploadFail($input, $wrap, {
      errorSelector,
      progressSelector,
      progressErrorClass,
    });

    const uploadStateOptions = {
      errorSelector,
      progressSelector,
      progressErrorClass,
      inputSelector,
    };

    hideUploadProgressContainer($wrap, progressSelector, progressErrorClass);

    $input.on('fileuploadadd', function (e, data) {
      const fieldsType = document.querySelector('#fields-type');

      if (fieldsType && fieldsType.value == fieldsTypeStandard) {
        if (!checkAddedFieldFiles(e.currentTarget, 'documents', 5)) {
          return false;
        }
      }

      showUploadProgress($wrap, progressSelector, progressErrorClass);
      $wrap.find(errorSelector).empty();
    });

    const imageUploadFormUrl = $result.data('url');

    $input.on('fileuploaddone', function (e, data) {
      if (data.result.status === 'ok') {
        const file = data.result.files[0];

        appendUploadResultHtml(
          $wrap,
          $input,
          $result,
          imageUploadFormUrl,
          { id: file.id },
          uploadStateOptions,
          function () {
            initSortable($result[0]);
          }
        );
      } else {
        const errorWrap = $wrap.find(errorSelector);

        if (Array.isArray(data.result.message)) {
          data.result.message.forEach(function (message) {
            errorWrap.append('<div>' + message + '</div>');
          });
        } else {
          errorWrap.text(data.result.message);
        }

        $progress.addClass(progressErrorClass);
      }
    });

    $input.on('fileuploadprogress', function (e, data) {
      const progress = parseInt(data.loaded / data.total * 100, 10);
      const progressPercent = progress + '%';
      $progress
        .removeClass(progressErrorClass)
        .attr('aria-valuenow', progress)
        .css('width', progressPercent)
        .text(progressPercent);
    });

    bindUploadResultRemove(
      $result,
      $wrap,
      inputSelector,
      resultItemSelector,
      resultRemoveSelector,
      uploadStateOptions
    );
  });
}

function initVideosUpload() {
  const wrapSelector = '.js-videos-upload';
  const inputSelector = '.js-videos-upload-input';
  const progressSelector = '.js-videos-upload-progress';
  const resultSelector = '.js-videos-upload-result';
  const resultItemSelector = '.js-videos-upload-result-item';
  const resultRemoveSelector = '.js-videos-upload-result-remove';
  const errorSelector = '.js-videos-upload-error';
  const loadingSelector = '.js-videos-upload-loading';
  const loadingHideClass = 'hidden';

  const $wrapList = $(wrapSelector);

  const progressErrorClass = 'progress__bar_error';

  $wrapList.each(function () {
    const $wrap = $(this);

    const $input = $wrap.find(inputSelector);
    const $progress = $wrap.find(progressSelector);
    const $result = $wrap.find(resultSelector);

    if (!$wrap.length || !$input.length || !$progress.length || !$result.length) return;
    if (!markUploadBound($wrap)) return;

    $input.fileupload({
      ...defaultFileuploadOptions,
      url: getUploadUrl($input),
      maxChunkSize: 10000000, // 10 MB
    });

    bindFileUploadFail($input, $wrap, {
      errorSelector,
      progressSelector,
      progressErrorClass,
      loadingSelector,
      loadingHideClass,
    });

    const uploadStateOptions = {
      errorSelector,
      progressSelector,
      progressErrorClass,
      loadingSelector,
      loadingHideClass,
      inputSelector,
    };

    hideUploadProgressContainer($wrap, progressSelector, progressErrorClass);

    $input.on('fileuploadadd', function (e, data) {
      const fieldsType = document.querySelector('#fields-type');

      if (fieldsType && fieldsType.value == fieldsTypeStandard) {
        if (!checkAddedFieldFiles(e.currentTarget, 'videos')) {
          return false;
        }
      }

      showUploadProgress($wrap, progressSelector, progressErrorClass);
      $wrap.find(errorSelector).empty();
      $wrap.find(loadingSelector).removeClass(loadingHideClass);
    });

    const videoUploadFormUrl = $result.data('url');

    $input.on('fileuploaddone', function (e, data) {
      $wrap.find(loadingSelector).addClass(loadingHideClass);

      if (data.result.status === 'ok') {
        const file = data.result.files[0];

        appendUploadResultHtml(
          $wrap,
          $input,
          $result,
          videoUploadFormUrl,
          { id: file.id },
          uploadStateOptions,
          function () {
            initSortable($result[0]);
          }
        );
      } else if (data.result.status === 'error') {
        const errorWrap = $wrap.find(errorSelector);

        if (Array.isArray(data.result.message)) {
          data.result.message.forEach(function (message) {
            errorWrap.append('<div>' + message + '</div>');
          });
        } else {
          errorWrap.text(data.result.message);
        }

        $progress.addClass(progressErrorClass);
        $input.val('');
      } else {
        resetUploadFieldState($wrap, $input, uploadStateOptions);
      }
    });

    $input.on('fileuploadprogress', function (e, data) {
      const progress = parseInt(data.loaded / data.total * 100, 10);
      const progressPercent = progress + '%';

      $progress
        .removeClass(progressErrorClass)
        .attr('aria-valuenow', progress)
        .css('width', progressPercent)
        .text(progressPercent);
    });

    bindUploadResultRemove(
      $result,
      $wrap,
      inputSelector,
      resultItemSelector,
      resultRemoveSelector,
      uploadStateOptions
    );
  });
}

function initAudiosUpload() {
  const wrapSelector = '.js-audios-upload';
  const inputSelector = '.js-audios-upload-input';
  const progressSelector = '.js-audios-upload-progress';
  const resultSelector = '.js-audios-upload-result';
  const resultItemSelector = '.js-audios-upload-result-item';
  const resultRemoveSelector = '.js-audios-upload-result-remove';
  const errorSelector = '.js-audios-upload-error';

  const $wrapList = $(wrapSelector);

  const progressErrorClass = 'progress__bar_error';

  $wrapList.each(function () {
    const $wrap = $(this);

    const $input = $wrap.find(inputSelector);
    const $progress = $wrap.find(progressSelector);
    const $result = $wrap.find(resultSelector);

    if (!$wrap.length || !$input.length || !$progress.length || !$result.length) return;
    if (!markUploadBound($wrap)) return;

    $input.fileupload({
      ...defaultFileuploadOptions,
      url: getUploadUrl($input),
    });

    bindFileUploadFail($input, $wrap, {
      errorSelector,
      progressSelector,
      progressErrorClass,
    });

    const uploadStateOptions = {
      errorSelector,
      progressSelector,
      progressErrorClass,
      inputSelector,
    };

    hideUploadProgressContainer($wrap, progressSelector, progressErrorClass);

    $input.on('fileuploadadd', function (e, data) {
      const fieldsType = document.querySelector('#fields-type');

      if (fieldsType && fieldsType.value == fieldsTypeStandard) {
        if (!checkAddedFieldFiles(e.currentTarget, 'audios')) {
          return false;
        }
      }

      showUploadProgress($wrap, progressSelector, progressErrorClass);
      $wrap.find(errorSelector).empty();
    });

    const audioUploadFormUrl = $result.data('url');

    $input.on('fileuploaddone', function (e, data) {
      if (data.result.status === 'ok') {
        const file = data.result.files[0];

        appendUploadResultHtml(
          $wrap,
          $input,
          $result,
          audioUploadFormUrl,
          { id: file.id },
          uploadStateOptions,
          function () {
            initSortable($result[0]);
          }
        );
      } else {
        const errorWrap = $wrap.find(errorSelector);

        if (Array.isArray(data.result.message)) {
          data.result.message.forEach(function (message) {
            errorWrap.append('<div>' + message + '</div>');
          });
        } else {
          errorWrap.text(data.result.message);
        }

        $progress.addClass(progressErrorClass);
      }
    });

    $input.on('fileuploadprogress', function (e, data) {
      const progress = parseInt(data.loaded / data.total * 100, 10);
      const progressPercent = progress + '%';
      $progress
        .removeClass(progressErrorClass)
        .attr('aria-valuenow', progress)
        .css('width', progressPercent)
        .text(progressPercent);
    });

    bindUploadResultRemove(
      $result,
      $wrap,
      inputSelector,
      resultItemSelector,
      resultRemoveSelector,
      uploadStateOptions
    );
  });
}

function initImagesUploadCropper() {
  let cropperElement = document.querySelector('#CropperModal');
  let uploadImageBlocks = document.querySelectorAll('.js-images-upload');

  // В embed-форме cropper-modal вне <form> — используем прямую загрузку
  if (isEmbedWorkContentPage()) {
    cropperElement = null;
  }

  if (cropperElement?.dataset.cropperInitBound === '1') {
    return;
  }

  if (!cropperElement) {
    uploadImageBlocks?.forEach(function (imageBlock) {
      const $wrap = $(imageBlock);
      const $input = $wrap.find('.js-image-upload-input-crop, .upload-image-input');

      bindDirectImageUploadInput($wrap, $input, {
        progressSelector: '.js-images-upload-progress',
        resultSelector: '.js-images-upload-result',
        resultRemoveSelector: '.js-images-upload-result-remove',
        errorSelector: '.js-images-upload-error',
        progressErrorClass: 'progress__bar_error',
      });
    });

    return;
  }

  cropperElement.dataset.cropperInitBound = '1';

  var cropperModal = new Modal($('#CropperModal'));
  let currentUploadImageInput;

  uploadImageBlocks?.forEach(function (imageBlock) {
    const uploadImageInput = imageBlock.querySelector('.upload-image-input, .js-image-upload-input-crop');

    if (!uploadImageInput || uploadImageInput.dataset.cropperChangeBound === '1') {
      return;
    }

    uploadImageInput.dataset.cropperChangeBound = '1';

    uploadImageInput.addEventListener('change', function() {
      if (!this.value) {
        return;
      }

      const parent = this.closest('.form__card');
      const errorBlock = parent?.querySelector('.field-action-status-messages');

      if (!canOpenHeroImageCropper(this)) {
        if (errorBlock) {
          errorBlock.innerHTML = '<div class="field_error_message">Превышено допустимое количество файлов для бесплатных конкурсов</div>';
        }

        this.value = '';
        return;
      }

      if (errorBlock) {
        errorBlock.innerHTML = '';
      }

      currentUploadImageInput = this;
      cropperModal.show();
    });
  });

  let moveBtns = document.querySelectorAll('.moveBtn');
  let image = document.querySelector('#crop-image');
  let cropContainer = document.querySelector('#crop-area');
  let confirmBtn = document.querySelector('#confirmCrop');
  let zoomInBtn = document.querySelector('#zoomIn');
  let zoomOutBtn = document.querySelector('#zoomOut');
  let rotateClockwise = document.querySelector('#rotate-clockwise'); // по часовой
  let rotateCounterclockwise = document.querySelector('#rotate-counterclockwise'); // против часовой
  let cropper;

  let enableCropButton = document.querySelector('#enableCropBtn'); // кнопка включения кропа
  let removeButtons = document.querySelectorAll('.js-images-upload-result-remove'); // кнопка удаления изображения
  let isCropEnabled = false;
  let loaderBlock = document.querySelector('.loader-block'); // спиннер загрузки

  function initializeCropper() {
    cropper?.destroy();

    cropper = new Cropper(image, {
      viewMode: 2,
      autoCrop: false,
      initialAspectRatio: 0,
      autoCropArea: 1,
      modal: true,
      cropBoxResizable: true,
      dragMode: 'move',
      background: true
    });
  }

  // отвечает за отображение/скрытие спиннера загрузки
  function loader(isVisible = true) {
    if (isVisible) {
      loaderBlock.style.display = 'block';
    } else {
      loaderBlock.style.display = 'none';
    }
  }

  document.querySelector('#CropperModal').addEventListener('shown.bs.modal', function() {
    cropContainer.style.display = 'block';
    confirmBtn.style.display = 'block';

    let files = currentUploadImageInput.files;

    let done = function(url) {
      currentUploadImageInput.value = '';
      image.src = url;
      initializeCropper();
    };

    let reader;
    let file;
    let url;

    if (files && files.length > 0) {
      file = files[0];

      if (URL) {
        done(URL.createObjectURL(file));
      } else if (FileReader) {
        reader = new FileReader();
        reader.onload = function(e) {
          done(reader.result);
        };
        reader.readAsDataURL(file);
      }
    }
  });

  function initRemoveButtons() {
    removeButtons = document.querySelectorAll('.js-images-upload-result-remove');
    removeButtons.forEach((element) => {
      if (element.dataset.removeBound === '1') {
        return;
      }

      element.dataset.removeBound = '1';
      element.addEventListener('click', () => {
        const uploadWrap = element.closest('.js-images-upload');
        element.closest('li.js-images-upload-result-item')?.remove();

        if (uploadWrap) {
          const $wrap = $(uploadWrap);
          const $input = $wrap.find('.js-images-upload-input, .upload-image-input, .js-image-upload-input-crop').first();

          resetUploadFieldState($wrap, $input, {
            errorSelector: '.js-images-upload-error',
            progressSelector: '.js-images-upload-progress',
            progressErrorClass: 'progress__bar_error',
          });
        }
      });
    });
  }

  initRemoveButtons();

  if (confirmBtn && confirmBtn.dataset.cropperConfirmBound !== '1') {
    confirmBtn.dataset.cropperConfirmBound = '1';

    confirmBtn.addEventListener('click', function(event) {
      event.preventDefault();

      if (!currentUploadImageInput || !cropper) {
        hideCropperModal(cropperModal, cropContainer, confirmBtn);
        return;
      }

      loader(true);

      const canvas = getCropperExportCanvas(cropper);

      if (!canvas) {
        loader(false);
        alert('Не удалось подготовить изображение. Попробуйте включить кроп или выбрать файл заново.');
        return;
      }

      const form = getWorkUploadFormElement(currentUploadImageInput);
      const formData = form ? new FormData(form) : new FormData();
      const dataUrl = canvas.toDataURL('image/jpeg');
      const blob = dataURItoBlob(dataUrl);
      const fieldUuid = currentUploadImageInput.getAttribute('field-uuid');

      if (fieldUuid) {
        formData.append(`image_${fieldUuid}`, blob, 'image.jpg');
      } else {
        formData.append('image', blob, 'image.jpg');
      }

      const uploadFileUrl = currentUploadImageInput.getAttribute('data-url');
      const uploadInputParent = currentUploadImageInput.closest('.js-images-upload');
      const uploadImagesResult = uploadInputParent?.querySelector('.js-images-upload-result');
      const uploadedImageUrl = uploadImagesResult?.getAttribute('data-url');

      fetch(uploadFileUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Ошибка: ${response.statusText}`);
          }

          return response.json();
        })
        .then((data) => {
          if (data.status !== 'ok' || !data.files?.[0]?.id) {
            throw new Error(data.message || 'Ошибка загрузки изображения');
          }

          const imageId = data.files[0].id;
          const hiddenInput = uploadInputParent?.querySelector('.js-images-upload-input-hidden');

          if (hiddenInput) {
            hiddenInput.value = imageId;
          }

          if (!uploadImagesResult || !uploadedImageUrl) {
            return;
          }

          return fetch(`${uploadedImageUrl}?id=${imageId}`, {
            method: 'GET',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
            .then((response) => response.json())
            .then((resultData) => {
              if (resultData?.html) {
                uploadImagesResult.innerHTML += resultData.html;
                initRemoveButtons();
              }
            });
        })
        .catch((error) => {
          console.error('Ошибка:', error);
          alert(`Произошла ошибка при отправке данных: ${error.message || error}`);
        })
        .finally(() => {
          loader(false);

          if (uploadInputParent) {
            const $wrap = $(uploadInputParent);
            const $input = $wrap.find('.js-images-upload-input, .upload-image-input, .js-image-upload-input-crop').first();

            resetUploadFieldState($wrap, $input, {
              errorSelector: '.js-images-upload-error',
              progressSelector: '.js-images-upload-progress',
              progressErrorClass: 'progress__bar_error',
            });
          }

          initRemoveButtons();
          hideCropperModal(cropperModal, cropContainer, confirmBtn);
        });
    });
  }

  // включение кропа
  enableCropButton?.addEventListener('click', (e) => {
    e.preventDefault();
    if (isCropEnabled) {
      cropper?.clear();
    } else {
      cropper?.crop();
    }
    isCropEnabled = !isCropEnabled;
  });

  // поворот по часовой стрелке
  rotateClockwise?.addEventListener('click', (e) => {
    e.preventDefault();
    cropper?.rotate(90).zoomTo(0.1);
  });

  // поворот против часовой стрелки
  rotateCounterclockwise?.addEventListener('click', (e) => {
    e.preventDefault();
    cropper?.rotate(-90).zoomTo(0.1);
  });

  zoomInBtn?.addEventListener('click', function(event) {
    event.preventDefault();
    cropper?.zoom(0.1);
  });

  zoomOutBtn?.addEventListener('click', function(event) {
    event.preventDefault();
    cropper?.zoom(-0.1);
  });

  Array.from(moveBtns).forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      if (cropper) {
        let direction = this.dataset.direction;
        let options = {
          up: [0, -10],
          down: [0, 10],
          left: [-10, 0],
          right: [10, 0]
        };
        cropper.move.apply(cropper, options[direction]);
      }
    });
  });

  function dataURItoBlob(dataURI) {
    let byteString = atob(dataURI.split(',')[1]);
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], {
      type: 'image/jpeg'
    });
  }
}

function initImagesUpload() {
  const wrapSelector = '.js-images-upload';
  const inputSelector = '.js-images-upload-input';
  const progressSelector = '.js-images-upload-progress';
  const resultSelector = '.js-images-upload-result';
  const resultItemSelector = '.js-images-upload-result-item';
  const resultRemoveSelector = '.js-images-upload-result-remove';
  const errorSelector = '.js-images-upload-error';

  const $wrapList = $(wrapSelector);

  const progressErrorClass = 'progress__bar_error';

  $wrapList.each(function () {
    const $wrap = $(this);

    const $input = $wrap.find(inputSelector);
    const $progress = $wrap.find(progressSelector);
    const $result = $wrap.find(resultSelector);

    if (!$wrap.length || !$input.length || !$progress.length || !$result.length) return;

    $input.fileupload({
      ...defaultFileuploadOptions,
      url: getUploadUrl($input),
    });

    bindFileUploadFail($input, $wrap, {
      errorSelector,
      progressSelector,
      progressErrorClass,
    });

    const uploadStateOptions = {
      errorSelector,
      progressSelector,
      progressErrorClass,
      inputSelector,
    };

    hideUploadProgressContainer($wrap, progressSelector, progressErrorClass);

    $input.on('fileuploadadd', function () {
      showUploadProgress($wrap, progressSelector, progressErrorClass);
      $wrap.find(errorSelector).empty();
    });

    const imageUploadFormUrl = $result.data('url');

    $input.on('fileuploaddone', function (e, data) {
      if (data.result.status === 'ok') {
        const file = data.result.files[0];

        appendUploadResultHtml(
          $wrap,
          $input,
          $result,
          imageUploadFormUrl,
          { id: file.id },
          uploadStateOptions,
          function () {
            initSortable($result[0]);
          }
        );
      } else {
        const errorWrap = $wrap.find(errorSelector);

        if (Array.isArray(data.result.message)) {
          data.result.message.forEach(function (message) {
            errorWrap.append('<div>' + message + '</div>');
          });
        } else {
          errorWrap.text(data.result.message);
        }

        $progress.addClass(progressErrorClass);
      }
    });

    $input.on('fileuploadprogress', function (e, data) {
      const progress = parseInt(data.loaded / data.total * 100, 10);
      const progressPercent = progress + '%';
      $progress
        .removeClass(progressErrorClass)
        .attr('aria-valuenow', progress)
        .css('width', progressPercent)
        .text(progressPercent);
    });

    bindUploadResultRemove(
      $result,
      $wrap,
      inputSelector,
      resultItemSelector,
      resultRemoveSelector,
      uploadStateOptions
    );
  });
}

function initMonoImageUpload() {
  const wrapSelector = '.js-image-upload';
  const inputSelector = '.js-image-upload-input';
  const hiddenInputSelector = '.js-image-upload-input-hidden';
  const progressSelector = '.js-image-upload-progress';
  const resultSelector = '.js-image-upload-result';
  const resultRemoveSelector = '.js-image-upload-result-remove';
  const errorSelector = '.js-image-upload-error';

  const $wrapList = $(wrapSelector);

  const progressErrorClass = 'progress__bar_error';

  $wrapList.each(function () {
    const $wrap = $(this);

    const $input = $wrap.find(inputSelector);
    const $hiddenInput = $wrap.find(hiddenInputSelector);
    const $progress = $wrap.find(progressSelector);
    const $result = $wrap.find(resultSelector);

    if (!$wrap.length || !$input.length || !$progress.length || !$result.length) return;

    $input.fileupload({
      ...defaultFileuploadOptions,
      url: getUploadUrl($input),
    });

    const uploadStateOptions = {
      errorSelector,
      progressSelector,
      progressErrorClass,
      inputSelector,
    };

    hideUploadProgressContainer($wrap, progressSelector, progressErrorClass);

    $input.on('fileuploadadd', function () {
      showUploadProgress($wrap, progressSelector, progressErrorClass);
      $wrap.find(errorSelector).empty();
    });

    $input.on('fileuploaddone', function (e, data) {
      if (data.result.status === 'ok') {

        const file = data.result.files[0];
        let resultHtml = '';

        $hiddenInput.val(file.id);

        resultHtml = '<a href="' + file.url + '" target="_blank"><img src="' + file.url + '?h=100' + '" alt=""></a>';
        resultHtml += '<button type="button" class="js-image-upload-result-remove ml-6" aria-label="Close"><i class="fas fa-times"></i></button>';

        $result.html(resultHtml);
        resetUploadFieldState($wrap, $input, uploadStateOptions);
      } else {
        $wrap.find(errorSelector).text(data.result.message);
        $progress.addClass(progressErrorClass);
      }
    });

    $input.on('fileuploadprogress', function (e, data) {
      const progress = parseInt(data.loaded / data.total * 100, 10);
      const progressPercent = progress + '%';
      $progress
        .removeClass(progressErrorClass)
        .attr('aria-valuenow', progress)
        .css('width', progressPercent)
        .text(progressPercent);
    });

    $result.on('click', resultRemoveSelector, function () {
      $hiddenInput.val(0);
      $result.empty();
      resetUploadFieldState($wrap, $input, uploadStateOptions);
    });
  });
}

// Для загрузки документов (pdf) на странице  Конкурс -> Информация о конкурсе
function initFileUpload() {
  const wrapSelector = '.js-file-upload';
  const inputSelector = '.js-file-upload-input';
  const hiddenInputSelector = '.js-file-upload-input-hidden';
  const progressSelector = '.js-file-upload-progress';
  const resultSelector = '.js-file-upload-result';
  const resultRemoveSelector = '.js-file-upload-result-remove';
  const errorSelector = '.js-file-upload-error';

  const $wrapList = $(wrapSelector);

  const progressErrorClass = 'progress__bar_error';

  $wrapList.each(function () {
    const $wrap = $(this);

    const $input = $wrap.find(inputSelector);
    const $hiddenInput = $wrap.find(hiddenInputSelector);
    const $progress = $wrap.find(progressSelector);
    const $result = $wrap.find(resultSelector);

    if (!$wrap.length || !$input.length || !$progress.length || !$result.length) return;

    $input.fileupload({
      ...defaultFileuploadOptions,
      url: getUploadUrl($input),
    });

    const uploadStateOptions = {
      errorSelector,
      progressSelector,
      progressErrorClass,
      inputSelector,
    };

    hideUploadProgressContainer($wrap, progressSelector, progressErrorClass);

    $input.on('fileuploadadd', function () {
      showUploadProgress($wrap, progressSelector, progressErrorClass);
      $wrap.find(errorSelector).empty();
    });

    $input.on('fileuploaddone', function (e, data) {
      if (data.result.status === 'ok') {

        const file = data.result.files[0];
        let resultHtml = '';

        $hiddenInput.val(file.id);

        resultHtml = '<a href="' + file.url + '" target="_blank">' + file.name + '</a>';
        resultHtml += '<button type="button" class="js-file-upload-result-remove ml-6" aria-label="Close"><i class="fas fa-times"></i></button>';

        $result.html(resultHtml);
        resetUploadFieldState($wrap, $input, uploadStateOptions);
      } else {
        const errorWrap = $wrap.find(errorSelector);

        if (Array.isArray(data.result.message)) {
          data.result.message.forEach(function (message) {
            errorWrap.append('<div>' + message + '</div>');
          });
        } else {
          errorWrap.text(data.result.message);
        }

        $progress.addClass(progressErrorClass);
      }
    });

    $input.on('fileuploadprogress', function (e, data) {
      const progress = parseInt(data.loaded / data.total * 100, 10);
      const progressPercent = progress + '%';
      $progress
        .removeClass(progressErrorClass)
        .attr('aria-valuenow', progress)
        .css('width', progressPercent)
        .text(progressPercent);
    });

    $result.on('click', resultRemoveSelector, function () {
      $hiddenInput.val(0);
      $result.empty();
      resetUploadFieldState($wrap, $input, uploadStateOptions);
    });
  });
}

// Загрузка файлов заявки в полях с выбранным форматом "Любой файл" (изображения, аудио, видео, документы)
// @KLUDGE сегодня нет времени переделывать дубль кода, в очереди 35 срочных задач
function initAnyFileUpload() {
  const wrapSelector         = '.js-anyfile-upload';
  const inputSelector        = '.js-anyfile-upload-input';
  const progressSelector     = '.js-anyfile-upload-progress';
  const resultSelector       = '.js-anyfile-upload-result';
  const resultItemSelector   = '.js-anyfile-upload-result-item';
  const resultRemoveSelector = '.js-anyfile-upload-result-remove';
  const errorSelector        = '.js-anyfile-upload-error';

  const $wrapList = $(wrapSelector);

  const progressErrorClass = 'progress__bar_error';

  $wrapList.each(function () {
    const $wrap = $(this);

    const $input = $wrap.find(inputSelector);
    const $progress = $wrap.find(progressSelector);
    const $result = $wrap.find(resultSelector);

    if (!$wrap.length || !$input.length || !$progress.length || !$result.length) return;
    if (!markUploadBound($wrap)) return;

    const anyFileUploadOptions = {
      ...defaultFileuploadOptions,
      url: getUploadUrl($input),
    };

    if (!isEmbedWorkContentPage()) {
      anyFileUploadOptions.maxChunkSize = 10000000; // 10 MB
    }

    $input.fileupload(anyFileUploadOptions);

    bindFileUploadFail($input, $wrap, {
      errorSelector,
      progressSelector,
      progressErrorClass,
    });

    const uploadStateOptions = {
      errorSelector,
      progressSelector,
      progressErrorClass,
      inputSelector,
    };

    hideUploadProgressContainer($wrap, progressSelector, progressErrorClass);

    $input.on('fileuploadadd', function () {
      showUploadProgress($wrap, progressSelector, progressErrorClass);
      $wrap.find(errorSelector).empty();
    });

    const uploadedFileUrl = $result.data('url');
    const fieldVariantUuid = $result.data('variant-uuid');

    $input.on('fileuploaddone', function (e, data) {
      if (data.result.status === 'ok') {
        const file = data.result.files[0];

        const params = {id: file.id, format: file.format};

        if (fieldVariantUuid) {
          params['fieldVariantUuid'] = fieldVariantUuid;
        }

        appendUploadResultHtml(
          $wrap,
          $input,
          $result,
          uploadedFileUrl,
          params,
          uploadStateOptions,
          function () {
            initDeleteFieldVariantFiles();
            initSortable($result[0]);
          }
        );
      } else {
        const errorWrap = $wrap.find(errorSelector);

        if (Array.isArray(data.result.message)) {
          data.result.message.forEach(function (message) {
            errorWrap.append('<div>' + message + '</div>');
          });
        } else {
          errorWrap.text(data.result.message);
        }

        $progress.addClass(progressErrorClass);
      }
    });

    $input.on('fileuploadprogress', function (e, data) {
      const progress = parseInt(data.loaded / data.total * 100, 10);
      const progressPercent = progress + '%';
      $progress
        .removeClass(progressErrorClass)
        .attr('aria-valuenow', progress)
        .css('width', progressPercent)
        .text(progressPercent);
    });

    bindUploadResultRemove(
      $result,
      $wrap,
      inputSelector,
      resultItemSelector,
      resultRemoveSelector,
      uploadStateOptions
    );
  });
}

export {
  initDocumentsUpload,
  initVideosUpload,
  initAudiosUpload,
  initImagesUpload,
  initMonoImageUpload,
  initFileUpload,
  initAnyFileUpload,
  initImagesUploadCropper
};
